import { Typography, IconButton, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

import { Props } from "./interfaces";
import { Title, Actions } from "./styles";
import { useRef } from "react";
import { dialogTitleId } from "./DialogHeaderPortal";

const DialogTitle = ({
  title,
  subtitle,
  handleClose,
  additionalButtons,
  headerActionButtons,
  additionalSection,
}: Props) => {
  const theme = useTheme();

  const portalRef = useRef(null);

  return (
    <Title>
      <Grid>
        <Grid sx={{ width: "100%", display: "flex", flexDirection: "row", alignItems: "center", gap: "10px" }}>
          <Typography
            variant="h6"
            component="span"
          >
            {title}
          </Typography>
          {headerActionButtons}
          <Grid
            ref={portalRef}
            id={dialogTitleId}
            sx={{ display: "flex", alignItems: "center" }}
          ></Grid>
        </Grid>
        {subtitle && <Typography variant="body2">{subtitle}</Typography>}
        {additionalSection}
      </Grid>

      <Actions>
        {additionalButtons}
        <IconButton
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            handleClose();
          }}
          style={{ color: theme.palette.error.main }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </IconButton>
      </Actions>
    </Title>
  );
};

export default DialogTitle;
